import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";

export const ChaseServicingSections = [
  sections.FEATURE,
  sections.PRIMARY_PHOTO,
  sections.COMPARABLE_TYPE,
  sections.ADDRESS,
  sections.LATITUDE,
  sections.LONGITUDE,
  sections.ADDRESS_2,
  sections.CITY,
  sections.STATE,
  sections.ZIP,
  sections.PROXIMITY_TO_SUBJECT,
  sections.SALE_PRICE,
  sections.SALE_PRICE_GLA,
  sections.DATA_SOURCES_1004P,
  sections.VALUE_ADJUSTMENTS,
  sections.SALE_OR,
  sections.FINANCING_CONCESSIONS,
  sections.SALE_1004P,
  sections.FINANCING_TYPE,
  sections.CONCESSION_AMOUNT,
  sections.CONCESSION_IF_OTHER,
  sections.DATE_OF_SALE_TIME,
  sections.STATUS_TYPE,
  sections.SALE_DATE_1004P,
  sections.CONTRACT_DATE,
  sections.LOCATION,
  sections.LOCATION_RATING,
  sections.LOCATION_TYPE,
  sections.LOCATION_TYPE_1_OTHER,
  sections.LOCATION_TYPE_2,
  sections.LOCATION_TYPE_2_OTHER,
  sections.SITE,
  sections.SQUARE_FEET,
  sections.ACRES,
  sections.ADJUSTMENTS_SITE,
  sections.VIEW,
  sections.VIEW_RATING,
  sections.VIEW_TYPE,
  sections.VIEW_TYPE_2,
  sections.DESIGN_STYLE,
  sections.ATT_DET,
  sections.STORIES,
  sections.DESIGN,
  sections.QUALITY,
  sections.ACTUAL_AGE_MVALUE,
  sections.CONDITION,
  sections.ABOVE_GRADE,
  sections.ABOVE_GRADE_ROOM_COUNT,
  sections.TOTAL,
  sections.BEDROOMS,
  sections.BATHROOMS,
  sections.HALF_BATHROOMS,
  sections.ADJUSTMENTS_ROOM_COUNT,
  sections.GLA,
  sections.ADJUSTMENTS_GLA,
  sections.BASEMENT_FINISHED,
  sections.BELOW_GRADE_TOT_SF,
  sections.BELOW_GRADE_FIN_SF,
  sections.BASEMENT_EXIT_TYPE,
  sections.GARAGE_CARPORT_MVALUE,
  sections.DRIVEWAY_ENABLED,
  sections.NUM_OF_CARS_MVALUE,
  sections.CAR_STORAGE_1_MVALUE,
  sections.ATTACHMENT_TYPE_1_MVALUE,
  sections.NUM_OF_CARS_1_MVALUE,
  sections.CAR_STORAGE_2_MVALUE,
  sections.ATTACHMENT_TYPE_2_MVALUE,
  sections.NUM_OF_CARS_2_MVALUE,
  sections.OTHER_MVALUE,
  sections.NET_ADJ,
  sections.ADJ_NET_PRICE,
  sections.ADJ_GROSS_PRICE,
];

export const ChaseServicingComparableCount = {
  minComparables: 3,
  maxComparables: 6
};